import * as React from 'react'

import { Box, CheckBox, Chevron, Icon } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import PlusMinus from 'modules/core/components/PlusMinus'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
const CHEVRON = 'chevron'
const PLUS_MINUS = 'plus-minus'
const CARET = 'caret'
const DISABLED = 'remove'
type Type = 'primary' | 'brand'
type Size = 'normal' | 'small'
type IconType = 'chevron' | 'plus-minus' | 'caret' | 'remove'
interface Props {
  opened: boolean
  type?: Type
  size?: Size
  renderHeader: () => React.ReactElement
  toggle: () => void
  expandIcon?: IconType
  bottomRadius?: boolean
  headerRounded?: boolean
  headerBorders?: boolean
  dropDownAnimated?: boolean
  scrollLimited?: boolean
  selected?: boolean
  onSelect?: () => void
}

const ExplotableItem = ({
  children,
  opened,
  renderHeader,
  toggle,
  expandIcon = 'chevron',
  type = 'primary',
  size = 'normal',
  dropDownAnimated = false,
  bottomRadius = true,
  headerBorders = true,
  scrollLimited = true,
  headerRounded = true,
  selected = false,
  onSelect,
}: React.PropsWithChildren<Props>) => {
  const iconPadding = onSelect ? 's4' : 's24'

  return (
    <li
      className={cx('expandableItem', type, size, {
        opened,
      })}
    >
      <div
        className={cx('header', {
          bottomRadius,
          headerBorders,
          headerRounded,
        })}
      >
        <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween" width="full">
          <Box
            onClick={toggle}
            paddingLeft={iconPadding}
            style={{
              cursor: 'pointer',
            }}
            flexDirection="row"
            alignItems="center"
          >
            {onSelect && (
              <Box paddingLeft="s24" paddingRight="s16" paddingTop="s2" minWidth="s24">
                <CheckBox onClick={onSelect} checked={selected} />
              </Box>
            )}
            {expandIcon === CARET && <Icon.Small icon={opened ? 'caret-down' : 'caret-right'} />}

            {expandIcon === CHEVRON && (
              <Chevron direction={opened ? 'up' : 'down'} type="terciary" />
            )}

            {expandIcon === PLUS_MINUS && <PlusMinus opened={opened} />}

            {expandIcon === DISABLED && <Icon.Small icon="remove" />}
            <Box>
              <div
                style={{
                  cursor: 'pointer',
                }}
                className={styles.content}
                onClick={toggle}
              >
                {renderHeader()}
              </div>
            </Box>
          </Box>
        </Box>
      </div>
      <div
        className={cx('dropdown', {
          dropDownAnimated,
          opened,
          scrollLimited,
          renderChildren: !!children,
        })}
      >
        {opened && children}
      </div>
    </li>
  )
}

export default observer(ExplotableItem)
